const ENABLE_MOBILE_INTROS = 'enable-mobile-intros';
const DISABLE_MOBILE_INTROS = 'disable-mobile-intros';

export { ENABLE_MOBILE_INTROS, DISABLE_MOBILE_INTROS };
